/**
 * Oceanographic Atlas foundation
 *
 * Direction: structural modernism × marine field notebook.
 * Type: Avenir Next for interface, a compact mono face for operational data.
 * Surfaces: deep ocean navigation, warm paper for analysis, no decorative glass.
 * Rhythm: 4 / 8 / 12 / 16 / 24 / 32 / 48 px. Accent colours always carry data.
 */

export const ATLAS_FONT_FAMILIES = Object.freeze({
  ui: '"Avenir Next", Avenir, "Gill Sans", "Trebuchet MS", sans-serif',
  display: 'Iowan Old Style, "Palatino Linotype", "Book Antiqua", Georgia, serif',
  data: '"SFMono-Regular", "Cascadia Code", "Roboto Mono", Menlo, monospace',
});

export const ATLAS_COLORS = Object.freeze({
  ink: '#102b3d',
  inkRaised: '#153851',
  paper: '#f2f0e8',
  paperRaised: '#faf9f4',
  rule: '#b9c4c1',
  fog: '#dce4df',
  ocean: '#176580',
  oceanLight: '#70b7be',
  sun: '#efc64a',
  coral: '#b9513d',
  focus: '#2aaec1',
});

// This is a semantic contract, not a new data palette. Product-specific
// scientific ramps remain authoritative; future charts and map overlays use
// these names to keep the same concept the same colour across the portal.
export const ATLAS_CHART_COLORS = Object.freeze({
  observed: '#173c56',
  forecast: '#b9513d',
  forecastShortRange: '#176580',
  climatology: '#2d748d',
  reference: '#69756f',
  uncertainty: '#b8c9c5',
  entireRegion: '#1f272a',
  north: '#b6423e',
  central: '#5b5f85',
  south: '#1d5c77',
});

export const ATLAS_RMI_ZONE_COLORS = Object.freeze({
  undp: Object.freeze({ North: '#b6423e', Central: '#5b5f85', South: '#1d5c77' }),
  practical: Object.freeze({ North: '#8b3d5c', Central: '#5b5f85', South: '#1d5c77' }),
  pccsp: Object.freeze({ North: '#b6423e', Central: '#5b5f85', South: '#1d5c77' }),
});

export const ATLAS_SPACING = Object.freeze({
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 48,
});
